import { Injectable } from '@angular/core';
import { MYACCOUNT_APPID, WIRELESS_ROUTE } from '@rci/self-serve-fido/app.constant';
import {
  AnalyticsConfiguration,
  pageViewEvent,
  selfServeCompleteWithPageViewEvents,
  selfServeStartWithPageViewEvents,
} from '@rci/self-serve-fido/core/analytics';
import { ICompleteUniversalDataLayer } from '@rogers/analytics';

const pageName = 'change my caller id';
const baseHierarchy = [MYACCOUNT_APPID, WIRELESS_ROUTE, pageName];

const page = {
  name: pageName,
  hierarchy: baseHierarchy,
};

const pageErrorEvent = {
  page,
  events: pageViewEvent,
};

const selfServeCallerId = {
  selfServe: {
    type: 'transaction',
    name: 'change caller id',
  },
};

@Injectable()
export class ChangeCallerIdAnalyticsConfigurationService implements AnalyticsConfiguration {
  mappings: Record<string, ICompleteUniversalDataLayer> = {
    callerIdPageOnLoad: {
      page,
      events: selfServeStartWithPageViewEvents,
      ...selfServeCallerId,
    },
    changeSuccess: {
      page,
      events: selfServeCompleteWithPageViewEvents,
      ...selfServeCallerId,
    },
    changeLimitExceededError: pageErrorEvent,
    changeEligibilityFailureError: pageErrorEvent,
    changeSubmitFailureError: pageErrorEvent,
    bannedWordError: pageErrorEvent,
    formFieldError: pageErrorEvent,
  };

  callBackFunctions?: Record<string, (payload: ICompleteUniversalDataLayer) => void> = {
    changeCallerId: () => {
      /* empty */
    },
  };
}
